import { useState } from "react";
import { Award, Printer } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useDash, courseProgress } from "@/components/dashboard/Layout";
import { PageHead, Card, Locked } from "@/components/dashboard/kit";
import { LOGO } from "@/data/content";

const Certificate = ({ name, course }) => (
  <div id="ilmora-certificate" className="rounded-2xl p-2" style={{ background: "linear-gradient(135deg,#c99a3c,#7a5514)" }}>
    <div className="rounded-xl bg-[#fffaf3] text-[#2a1a0c] p-8 sm:p-12 text-center">
      <img src={LOGO} alt="Ilmora Academy" className="h-14 w-auto mx-auto object-contain" />
      <p className="text-xs tracking-[0.3em] uppercase mt-4 text-[#9f3158] font-bold">Certificate of Completion</p>
      <p className="text-sm mt-6">This certifies that</p>
      <p data-testid="certificate-name" className="font-display text-3xl sm:text-4xl font-bold mt-2">{name}</p>
      <p className="text-sm mt-4">has successfully completed the course</p>
      <p className="font-display text-xl font-semibold mt-2 text-[#9f3158]">{course}</p>
      <div className="flex justify-between items-end mt-10 text-xs">
        <div className="text-left"><p className="font-semibold">{new Date().toLocaleDateString("en-IN")}</p><p className="text-[#6b5a45]">Date</p></div>
        <div className="text-right"><p className="font-display text-base font-semibold">Ilmora Academy</p><p className="text-[#6b5a45]">Her Hijab · Her Skills · Her Success</p></div>
      </div>
    </div>
  </div>
);

export default function Certificates() {
  const { user, courses, progress, approved } = useDash();
  const [open, setOpen] = useState(null);
  if (!approved) return <div data-testid="certificates-page"><PageHead title="My" highlight="Certificates" /><Locked /></div>;

  return (
    <div data-testid="certificates-page">
      <PageHead title="My" highlight="Certificates" sub="Finish every lesson of a course to unlock its certificate." />
      <div className="grid sm:grid-cols-2 gap-5">
        {courses.map((c) => {
          const p = courseProgress(progress, c);
          return (
            <Card key={c.slug} className="flex items-center gap-4" data-testid={`cert-card-${c.slug}`}>
              <div className="icon-orb shrink-0"><Award size={20} /></div>
              <div className="flex-1 min-w-0"><p className="font-semibold truncate">{c.title}</p><p className="text-xs text-[var(--muted)]">{p.pct}% complete</p></div>
              <button data-testid={`cert-view-${c.slug}`} disabled={p.pct < 100} onClick={() => setOpen(c.title)} className="btn-neon !px-4 !py-2 text-xs disabled:opacity-40 disabled:cursor-not-allowed">{p.pct < 100 ? "Locked" : "View"}</button>
            </Card>
          );
        })}
      </div>
      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="max-w-2xl !bg-[var(--bg)] border-[var(--surface-border)] rounded-3xl">
          <DialogTitle className="sr-only">Certificate</DialogTitle>
          <Certificate name={user.name} course={open} />
          <button data-testid="cert-print-btn" onClick={() => window.print()} className="btn-ghost justify-center text-sm"><Printer size={15} /> Print / Save as PDF</button>
        </DialogContent>
      </Dialog>
    </div>
  );
}
